import { CardProduct } from 'components/Cards/CardProduct'
import { Box } from '@achieve/ascend'
import { Carousel } from 'components/Carousels'
import { CardProductListItem } from 'components/Cards/CardProductListItem'

function Card({ item, productCardVariant }) {
  return (
    <div className={'flex flex-col h-full px-4 py-0'}>
      {item && productCardVariant === 'ProductCardsListItem' ? (
        <CardProductListItem content={item} />
      ) : (
        <CardProduct content={item} />
      )}
    </div>
  )
}

function CardCarousel({ content = {}, isMobile, productCardVariant }) {
  const containsCardBadge = Boolean(
    content.gridItems.findIndex((item) => item.fields?.cardBadgeImage) >= 0
  )
  if (productCardVariant === 'ProductCardsListItem') {
    return (
      <>
        {content && (
          <Box data-variant="carousel">
            <Carousel
              carouselItems={content?.gridItems || []}
              itemComponent={({ item: cardItem }) => (
                <Card item={cardItem} productCardVariant={productCardVariant} />
              )}
              variant="auto"
              idPrefix="value-props-carousel"
              className={'mb-6 p-0'}
              classNameItems={'last:mr-[88px]'}
              classNameContainer={'gap-4 w-[99%]'}
              classNameIndicators={''}
              classNameActiveDot={'[&_button]:bg-[#30f] opacity-100'}
              classNameControls={''}
              carouselThreshold={[1]}
            />
          </Box>
        )}
      </>
    )
  } else {
    return (
      <>
        {content && (
          <Carousel
            className={''}
            carouselItems={content?.gridItems || []}
            itemComponent={({ item: cardItem }) => (
              <Card item={cardItem} productCardVariant={productCardVariant} />
            )}
            variant="preview-stretch"
            idPrefix="value-props-carousel"
            withIndicators={isMobile}
            classNameIndicators={'[&>div]:bg-[#c0cbd8]'}
            classNameActiveDot={'[&_button]:bg-[#30f] opacity-100'}
            withBadges={containsCardBadge}
          />
        )}
      </>
    )
  }
}

export { CardCarousel }
